import PO from './programOptions'

const numberOfZonesNumbers = [
  PO.NUMBER_OF_ZONES_1375,
]

export default numberOfZonesNumbers
